import React from 'react';
import { IonApp, IonContent, IonFooter, IonPage } from '@ionic/react';

export default function MiIonicAppShell({ topBar, children, footer, overlays }) {
  return (
    <IonApp className="mi-ionic-app-shell">
      <IonPage className="mi-ionic-page">
        {topBar}
        <IonContent fullscreen scrollY className="mi-ionic-content">
          <div className="mi-ionic-content__inner">
            {children}
          </div>
        </IonContent>
        <IonFooter className="mi-ionic-footer">
          {footer}
        </IonFooter>
      </IonPage>
      {overlays}
    </IonApp>
  );
}
